<template>
  <div>
    Display OSA Configuration Here...
  </div>
</template>

<script>
export default {
  name: 'OSAConfig',
  data: function () {
    return {
    }
  },
  computed: {
  },
  methods: { },
}
</script>

<style lang="scss" scoped>
</style>
